<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col cols="1">
        <b-btn
          variant="success"
          @click="showNewEnumModal = true"
          :disabled="selectedEnum == null"
        >
          {{ $t("globals.new") }}
        </b-btn>
      </b-col>
      <b-col>
        <b-input-group>
          <b-input-group-prepend>
            <b-form-select
              v-model="selectedEnum"
              :options="[{ text: 'All', value: null }, ...getEnumTypeOptions]"
            />
          </b-input-group-prepend>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small
          primary-key="id"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          :items="items"
          :fields="fields"
          @filtered="onFiltered"
        >
          <template v-slot:cell(actions)="row">
            <b-btn
              v-if="row.item.active == 'true'"
              variant="warning"
              style="margin-left: 3px;"
              size="sm"
              @click="toggleActive(row.item.id, false)"
            >
              Disable
            </b-btn>
            <b-btn
              v-else
              variant="success"
              style="margin-left: 3px;"
              size="sm"
              @click="toggleActive(row.item.id, true)"
            >
              Enable
            </b-btn>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-1">
        <b-pagination
          :total-rows="items.length"
          :per-page="perPage"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
    <ulu-create-enum-modal
      :show="showNewEnumModal"
      :close="closeModals"
      :enumType="selectedEnum"  
    />
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  components: {
    "ulu-create-enum-modal": () =>
      import("@/components/admin/enums/NewEnumModal")
  },
  data() {
    return {
      selectedEnum: null,
      showNewEnumModal: false,
      items: [],
      filter: null,
      currentPage: 1,
      perPage: 20,
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      fields: [
        {
          key: "id",
          sortable: true
        },
        {
          key: "enum_type",
          label: this.$t("globals.type"),
          sortable: true
        },
         {
          key: "active",
          sortable: true
        },
        {
          key: "name",
          sortable: true
        },
        {
          key: "value",
          sortable: true
        },
        {
          key: "description",
          label: this.$t("globals.description"),
          sortable: true
        },
        {
          key: "actions",
          label: this.$t("globals.actions")
        },
      ]
    };
  },
  computed: {
    ...mapGetters("constants", ["getEnumTypeOptions"])
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleFetch", "simpleMutation"]),
    fetchAllEnums() {
      const data = {
        query: `
          query {
            enumsAll {
              id
              enum_type
              active
              name
              value
              description
              _rowVariant
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.items = res.enumsAll;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
    fetchEnumsByCategory(category) {
      const data = {
        query: `
          query {
            enumsAll(enum_type: "${category}") {
              id
              enum_type
              active
              name
              value
              description
              _rowVariant
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.items = res.enumsAll;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
    toggleActive(id, activeSet) {
      let data = {
        query: `
          mutation EnumEdit($enum: BillingEnumInput) {
            res: EnumEdit (enum: $enum)
          }
        `,
        variables: {
          enum: {
            id: id,
            active: activeSet
          }
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.closeModals();
      });
    },
    closeModals() {
      this.showNewEnumModal = false;

      this.selectedEnum = null;
      this.fetchAllEnums();
    },
    onFiltered() {
      this.currentPage = 1;
    }
  },
  watch: {
    selectedEnum(new_val) {
      if (new_val) {
        this.fetchEnumsByCategory(new_val);
      } else {
        this.fetchAllEnums();
      }
    }
  },
  mounted() {
    this.fetchAllEnums();
  }
};
</script>
